module.exports = __webpack_public_path__ + "static/media/logo_blanco.65030376.svg";